import { Component, OnInit, ViewChild, AfterViewInit, ViewEncapsulation, Input, Renderer2, ChangeDetectorRef } from '@angular/core';
import * as _ from 'lodash';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { BaseGridUIComponent } from '@app/cp/shared/base-components/base-grid-ui.component';
import { RelatedJobBus } from '@app/cp/shared/models/RelatedJobBus';
import { ConstructionService } from '@app/cp/shared/services/construction.service';
import { BaseGridEditLineComponent } from '@app/cp/shared/base-components/base-grid-editline.component';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { aggregateBy } from '@progress/kendo-data-query';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { DateFunctions } from '@app/cp/shared/static/date-functions';
import { MSCLFilterClass } from '@app/cp/shared/classes/filters/MSCLFilterClass';
import { DQOIParam } from '@app/cp/shared/models/DQOIParam';
import { SearchTarget } from '@app/cp/shared/enums/SearchTarget';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { process } from '@progress/kendo-data-query';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
@Component({
    selector: 'contract-change-orders',
    templateUrl: './contract-change-orders.component.html',
    styleUrls: ['./contract-change-orders.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ContractChangeOrdersComponent extends BaseGridEditLineComponent<RelatedJobBus, null, ConstructionService>  {
    dispatchStatusNameCF: MSCLFilterClass;
    accountClassNameCF: MSCLFilterClass;
    quoteStatusNameCF: MSCLFilterClass;
    coCF: MSCLFilterClass;
    crCF: MSCLFilterClass;

    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, svc_data: ConstructionService, featureFlagService: FeatureFlagService) {

        super(globals, renderer, cd, featureFlagService);
        this.allData = this.allData.bind(this);
        this.svc_data = svc_data;
        this.className = "RelatedJobBus";
        this.appCode = "ChangeOrders";

        this.aggregates = [
            { field: 'totalCosts', aggregate: 'sum' },
            { field: 'totalQuoteCost', aggregate: 'sum' },
            { field: 'totalQuote', aggregate: 'sum' }
        ];
        this.disableCpSearchDialog();
    }
    createForm() {
        this.editForm = new UntypedFormGroup({
            'relatedJobId': new UntypedFormControl(),
            'dispatchId': new UntypedFormControl(),
            'dispatchNumber': new UntypedFormControl(),
            'changeOrderInfo': new UntypedFormControl(),
            'accountClassName': new UntypedFormControl(),
            'quoteDesc': new UntypedFormControl(),
            'totalCosts': new UntypedFormControl(),
            'quoteNumber': new UntypedFormControl(),
            'changeReqInfo': new UntypedFormControl(),
            'quoteStatusName': new UntypedFormControl(),
            'statusDate': new UntypedFormControl(),
            'dispatchReason': new UntypedFormControl(),
            'totalQuoteCost': new UntypedFormControl(),
            'totalQuote': new UntypedFormControl(),
        });

    }
    setForm() {
        this.editForm.patchValue({
            relatedJobId: this.selectedData.relatedJobId,
            dispatchId: this.selectedData.dispatchId,
            dispatchNumber: this.selectedData.dispatchNumber,
            changeOrderInfo: this.selectedData.changeOrderInfo,
            accountClassName: this.selectedData.accountClassName,
            quoteDesc: this.selectedData.quoteDesc,
            totalCosts: this.selectedData.totalCosts,
            quoteNumber: this.selectedData.quoteNumber,
            changeReqInfo: this.selectedData.changeReqInfo,
            quoteStatusName: this.selectedData.quoteStatusName,
            statusDate: this.selectedData.quoteStatusDate,
            dispatchReason: this.selectedData.dispatchReason,
            totalQuoteCost: this.selectedData.totalQuoteCost,
            totalQuote: this.selectedData.totalQuote
        });
    }
    get canAddNew(): boolean {
        return true;
    }
    addChangeOrder() {
        let param: DQOIParam = new DQOIParam();
        param.target = SearchTarget.job;
        param.code = "NEWCHANGEORDER";
        this.goToWithParam(param);
    }
    getChangedObject(data: RelatedJobBus) {
        let busObj: RelatedJobBus = new RelatedJobBus(data);
        busObj.setCommon(this.globals.userId, DateFunctions.getDateNow(), this.globals.companyId, this.globals.personId);
        busObj.setParentId(this._parentId);
        busObj.setBeforeSave();
        return busObj;
    }
    processGridData() {
        if (CommonFunctions.hasArrayElementValue(this.gridData)) {
            this.aggregateResults = aggregateBy(this.gridData, this.aggregates);
        }
        this.dispatchStatusNameCF = new MSCLFilterClass('dispatchStatusName', 'dispatchStatusName', this.gridData);
        this.accountClassNameCF = new MSCLFilterClass('accountClassName', 'accountClassName', this.gridData);
        this.quoteStatusNameCF = new MSCLFilterClass('quoteStatusName', 'quoteStatusName', this.gridData);
        this.coCF = new MSCLFilterClass('changeOrderInfo', 'changeOrderInfo', this.gridData);
        this.crCF = new MSCLFilterClass('changeReqInfo', 'changeReqInfo', this.gridData);
    }
    public allData(indata: ExcelExportData): ExcelExportData {
        if (!this.gridData) this.gridData = [];
        const result: ExcelExportData = {
            data: process(this.gridData as any, {}).data,
        };
        return result;
    }
    public exportGridToExcel(): void {

        this.grid.saveAsExcel();
    }
}
